module.exports = __webpack_public_path__ + "static/media/4.b4f1ffe3.jpeg";